// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const TimeFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M59.32 61.681a2 2 0 0 0 .266-2.816l-9.584-11.58V27.843a2 2 0 0 0-4 0v20.164a2 2 0 0 0 .459 1.275l10.043 12.134c.395.478.966.725 1.542.725.449 0 .901-.15 1.274-.46M48.002 83.5C28.425 83.5 12.5 67.578 12.5 48.006 12.5 28.429 28.425 12.5 48.002 12.5 67.575 12.5 83.5 28.429 83.5 48.007c0 19.57-15.925 35.492-35.498 35.492"
			fillRule="evenodd"
		/>
	</svg>
);
export default TimeFilled;
